export const DEFAULT_SIMULATED_DELAY = 300;

export const SESSION_KEY = 'session_id';
